export const getFinalTotalFromSummary = (summary, discount = 0) => {
  const summaryTotal = Number(summary?.total || 0)
  const appliedDiscount = Number(discount || 0)

  return Math.max(0, summaryTotal - appliedDiscount)
}
